import {getViewSettingsSafely, ViewIdentifiable} from "../../models/common/ViewSettings";
import {ErrorAction, ReduxAction} from "../../models/common/ActionTypes";
import {SelectComponentCapable} from "../../models/common/Form";
import {ApiReturnType} from "../../models/common/ApiReturnType";
import {AppState} from "../../reducers/RootReducer";
import {APP_CONFIG} from "../../config/GeneralConfig";
import {getUrlParamsFromViewSettings} from "../../config/RouteConfig";
import {eventNotificationShow} from "../common/EventNotificationActions";
import {EVENT_NOTIFICATION_TYPE} from "../../helpers/EventNotificationType";
import {createErrorResponse} from "../../config/languages/definitions/AjaxResponses";
import {ProjectStageModule, ProjectStageShort, ProjectStage} from "../../models/projects/ProjectStage";
import { StateObservable, ofType } from "redux-observable";
import { switchMap, filter, map, catchError } from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { Observable, of } from 'rxjs';

export type ProjectStageViewActionTypes = FetchProjectStagesActionTypes

export interface FetchProjectStagesAction extends ViewIdentifiable, ReduxAction< typeof FETCH_PROJECT_STAGES >, SelectComponentCapable {
    projectId: number
}
export interface FetchProjectStagesSuccessAction extends ViewIdentifiable, ReduxAction<typeof FETCH_PROJECT_STAGES_SUCCESS > {
    payload: ApiReturnType< ProjectStage[] | ProjectStageShort[] >
}
export interface FetchProjectStagesErrorAction extends ViewIdentifiable, ErrorAction< typeof FETCH_PROJECT_STAGES_ERROR >{}

export type FetchProjectStagesActionTypes = FetchProjectStagesAction | FetchProjectStagesErrorAction | FetchProjectStagesSuccessAction


export const FETCH_PROJECT_STAGES = "FETCH_PROJECT_STAGES";
export const FETCH_PROJECT_STAGES_SUCCESS = "FETCH_PROJECT_STAGES_SUCCESS";
export const FETCH_PROJECT_STAGES_ERROR = "FETCH_PROJECT_STAGES_ERROR";

export const fetchProjectStages = ( viewIdentifier: string, projectId: number, isFetchForSelect: boolean = false ) : FetchProjectStagesAction =>
    ({ type: FETCH_PROJECT_STAGES, viewIdentifier, isFetchForSelect, projectId });
export const fetchProjectStagesSuccess = ( viewIdentifier: string, payload: ApiReturnType< ProjectStage[] | ProjectStageShort[] > ) : FetchProjectStagesSuccessAction =>
    ({ type: FETCH_PROJECT_STAGES_SUCCESS, viewIdentifier, payload });
export const fetchProjectStagesError = ( viewIdentifier: string, error: Error ): FetchProjectStagesErrorAction =>
    ({ type: FETCH_PROJECT_STAGES_ERROR, viewIdentifier, error });

export function fetchProjectStagesEpic(
    action$: Observable< FetchProjectStagesAction >,
    store$: StateObservable< AppState >
) {
    return action$.pipe(
        ofType(FETCH_PROJECT_STAGES),
        filter(action => action.viewIdentifier === ProjectStageModule.identifier),
        switchMap(action => {
            const viewSettings = getViewSettingsSafely(action.viewIdentifier, store$);
            const path = `${APP_CONFIG.baseWeb}projects/${action.projectId}/stages/${getUrlParamsFromViewSettings(viewSettings)}`;
            const language = store$.value.LanguageReducer.current;

            return ajax(APP_CONFIG.getRequestObject(path)).pipe(
                map(response => fetchProjectStagesSuccess(
                    action.viewIdentifier,
                    response.response as ApiReturnType< ProjectStage[] >
                )),
                catchError(error => of(
                    fetchProjectStagesError(action.viewIdentifier, error),
                    eventNotificationShow(EVENT_NOTIFICATION_TYPE.customAjaxError, createErrorResponse(language, error.status, action.viewIdentifier, "fetchProjectStages"))
                ))
            );

        })
    );
}